export default __webpack_public_path__ + "static/media/30_photo.a118542e.jpeg";